import { Component, OnInit } from '@angular/core';
import { WellnessTaskTemplate, WellnessTaskTemplateGenSvc } from 'src/app/services_autogenerated/generated_services';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-wellness-task-template-maintenance',
    templateUrl: './wellness-task-template-maintenance.component.html',
    styleUrls: ['./wellness-task-template-maintenance.component.css'],
    standalone: false
})
export class WellnessTaskTemplateMaintenanceComponent implements OnInit {
  task: WellnessTaskTemplate;
  taxCodes: any[];
  disableDelete: boolean;
  saving: boolean;

  constructor(
    private wellnessTaskTemplateService: WellnessTaskTemplateGenSvc,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.taxCodes = [
      { label: 'Taxable', value: 'tax' },
      { label: 'Tax Exempt', value: 'untaxed' }
    ];
  }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');
    if (id) {
      this.wellnessTaskTemplateService.get(id).subscribe(task => {
        this.task = task;
      });
    } else {
      this.disableDelete = true;
      this.task = new WellnessTaskTemplate();
      this.task.active = true;
    }
  }

  save(ngForm: NgForm): void {
    if ('activeElement' in document) {
      (document.activeElement as HTMLElement).blur();
    }
    // There was an error where cost would be zeroed if the user was editing it when the hit enter
    // This is a janky solution
    setTimeout(() => this.actualSave(ngForm), 0);
  }

  actualSave(ngForm: NgForm): void {
    Object.keys(ngForm.controls).forEach(key => {
      ngForm.controls[key].markAsTouched();
      ngForm.controls[key].markAsDirty();
    });
    if (ngForm.valid) {
      this.saving = true;
      if (this.task.id) {
        this.wellnessTaskTemplateService.update(this.task, this.task.id.toString())
          .subscribe(() => {
            this.doneSaving();
          }, error => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Saving',
              detail: 'Could not save the task template, please check that all fields are valid and retry.'
            });
            this.doneSaving();
          });
      } else {
        this.wellnessTaskTemplateService.add(this.task)
          .subscribe(() => {
            this.doneSaving();
          }, error => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Saving',
              detail: 'Could not save the task template, please check that all fields are valid and retry.'
            });
            this.doneSaving();
          });
      }
    }
  }

  private doneSaving() {
    this.saving = false;
    this.router.navigateByUrl('/wellnessTaskTemplateList');
  }

  cancel() {
    this.router.navigateByUrl('/wellnessTaskTemplateList');
  }

  delete() {
    if (confirm('Would you like to delete this wellness task template?')) {
      this.wellnessTaskTemplateService.delete(this.task.id).subscribe(() => {
        this.router.navigateByUrl('/wellnessTaskTemplateList');
      }, error => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Deleting',
          detail: 'Could not delete the task, please check that the task exists and retry.'
        });
      });
    }
  }
}
